// UI translation dictionaries. Non-RTL languages only.
export const LANGUAGES = [
  { code: "en", label: "English", flag: "🇺🇸" },
  { code: "es", label: "Español", flag: "🇪🇸" },
  { code: "fr", label: "Français", flag: "🇫🇷" },
  { code: "de", label: "Deutsch", flag: "🇩🇪" },
  { code: "pt", label: "Português", flag: "🇵🇹" },
];

// AI can target these languages when writing/translating résumé content
export const AI_LANGUAGES = [
  "English", "Spanish", "French", "German", "Portuguese",
  "Italian", "Dutch", "Hindi", "Chinese (Simplified)", "Japanese",
];

export const translations = {
  en: {
    "nav.watchDemo": "Watch Demo", "nav.buildResume": "Build My Resume",
    "hero.badge": "AI-Powered Career Platform",
    "sections.templatesTitle": "Designed around your story",
    "sections.templatesSub": "Once your content is right, choose the presentation that fits you.",
    "footer.tagline": "Recruiter-vetted résumé styles, an AI Career Copilot360, and shareable digital portfolios — all in one studio.",
    "footer.product": "Product", "footer.resources": "Resources", "footer.contact": "Get in touch",
    "footer.editor": "ResumePilot360 Editor", "footer.templates": "Styles", "footer.howItWorks": "How it works",
    "footer.importChatgpt": "Import from ChatGPT", "footer.watchDemo": "Watch demo", "footer.pricing": "Pricing",
    "footer.myResumes": "My résumés", "footer.privacy": "Privacy", "footer.terms": "Terms", "footer.support": "Support",
    "footer.rights": "All rights reserved.",
  },
  es: {
    "nav.watchDemo": "Ver demo", "nav.buildResume": "Crear Mi Currículum",
    "hero.badge": "Plataforma de Carrera con IA",
    "sections.templatesTitle": "Diseñado en torno a tu historia",
    "sections.templatesSub": "Diseños generados por IA que mantienen tu historia clara, profesional y compatible con ATS.",
    "footer.tagline": "Estilos de CV aprobados por reclutadores, un copiloto de carrera con IA y portafolios digitales para compartir, todo en un solo estudio.",
    "footer.product": "Producto", "footer.resources": "Recursos", "footer.contact": "Contacto",
    "footer.editor": "Editor ResumePilot360", "footer.templates": "Estilos", "footer.howItWorks": "Cómo funciona",
    "footer.importChatgpt": "Importar de ChatGPT", "footer.watchDemo": "Ver demo", "footer.pricing": "Precios",
    "footer.myResumes": "Mis CV", "footer.privacy": "Privacidad", "footer.terms": "Términos", "footer.support": "Soporte",
    "footer.rights": "Todos los derechos reservados.",
  },
  fr: {
    "nav.watchDemo": "Voir la démo", "nav.buildResume": "Créer Mon CV",
    "hero.badge": "Plateforme de Carrière Propulsée par l'IA",
    "sections.templatesTitle": "Conçu autour de votre parcours",
    "sections.templatesSub": "Des mises en page générées par IA qui gardent votre parcours clair, professionnel et compatible ATS.",
    "footer.tagline": "Des styles de CV validés par des recruteurs, un copilote de carrière IA et des portfolios numériques partageables — le tout dans un seul studio.",
    "footer.product": "Produit", "footer.resources": "Ressources", "footer.contact": "Nous contacter",
    "footer.editor": "Éditeur ResumePilot360", "footer.templates": "Styles", "footer.howItWorks": "Comment ça marche",
    "footer.importChatgpt": "Importer depuis ChatGPT", "footer.watchDemo": "Voir la démo", "footer.pricing": "Tarifs",
    "footer.myResumes": "Mes CV", "footer.privacy": "Confidentialité", "footer.terms": "Conditions", "footer.support": "Assistance",
    "footer.rights": "Tous droits réservés.",
  },
  de: {
    "nav.watchDemo": "Demo ansehen", "nav.buildResume": "Lebenslauf Erstellen",
    "hero.badge": "KI-gestützte Karriereplattform",
    "sections.templatesTitle": "Gestaltet um deine Geschichte",
    "sections.templatesSub": "KI-generierte Layouts, die deine Geschichte klar, professionell und ATS-freundlich halten.",
    "footer.tagline": "Von Recruitern geprüfte Lebenslauf-Stile, ein KI-Karriere-Copilot und teilbare digitale Portfolios — alles in einem Studio.",
    "footer.product": "Produkt", "footer.resources": "Ressourcen", "footer.contact": "Kontakt",
    "footer.editor": "ResumePilot360-Editor", "footer.templates": "Stile", "footer.howItWorks": "So funktioniert's",
    "footer.importChatgpt": "Aus ChatGPT importieren", "footer.watchDemo": "Demo ansehen", "footer.pricing": "Preise",
    "footer.myResumes": "Meine Lebensläufe", "footer.privacy": "Datenschutz", "footer.terms": "AGB", "footer.support": "Support",
    "footer.rights": "Alle Rechte vorbehalten.",
  },
  pt: {
    "nav.watchDemo": "Ver demo", "nav.buildResume": "Criar Meu Currículo",
    "hero.badge": "Plataforma de Carreira com IA",
    "sections.templatesTitle": "Desenhado em torno da sua história",
    "sections.templatesSub": "Layouts gerados por IA que mantêm sua história clara, profissional e compatível com ATS.",
    "footer.tagline": "Estilos de currículo aprovados por recrutadores, um copiloto de carreira com IA e portfólios digitais compartilháveis — tudo em um só estúdio.",
    "footer.product": "Produto", "footer.resources": "Recursos", "footer.contact": "Fale conosco",
    "footer.editor": "Editor ResumePilot360", "footer.templates": "Estilos", "footer.howItWorks": "Como funciona",
    "footer.importChatgpt": "Importar do ChatGPT", "footer.watchDemo": "Ver demo", "footer.pricing": "Preços",
    "footer.myResumes": "Meus currículos", "footer.privacy": "Privacidade", "footer.terms": "Termos", "footer.support": "Suporte",
    "footer.rights": "Todos os direitos reservados.",
  },
};
